<template>
  <el-dialog
    title="提现审核"
    :visible.sync="innerVisible"
    width="520px"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div class="dlg-body">
      <div class="info-row">
        <span class="label">门店名称</span>
        <span class="value">{{ row.storeName || "-" }}</span>
      </div>
      <div class="info-row">
        <span class="label">区域负责人</span>
        <span class="value">{{ row.areaFollowUserName || "-" }}</span>
      </div>
      <div class="info-row">
        <span class="label">提现金额</span>
        <span class="value">{{ row.amount != null && row.amount !== "" ? row.amount : "-" }}</span>
      </div>
      <el-form ref="formRef" :model="formData" :rules="formRules" label-width="100px" size="small">
        <el-form-item label="审核状态" prop="reviewStatus">
          <el-radio-group v-model="formData.reviewStatus">
            <el-radio :label="AUDIT_PASS">审核通过</el-radio>
            <el-radio :label="AUDIT_REJECT">审核拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="reviewRemark">
          <el-input
            v-model.trim="formData.reviewRemark"
            type="textarea"
            :rows="4"
            placeholder="请输入审核备注"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="innerVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="onSubmit">
        提交
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { submitWithdrawalAuditAPI } from "../api";

/** 审核通过 */
const AUDIT_PASS = 2;
/** 审核拒绝 */
const AUDIT_REJECT = 3;

export default {
  name: "WithdrawAuditDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      innerVisible: false,
      submitting: false,
      AUDIT_PASS,
      AUDIT_REJECT,
      formData: {
        reviewStatus: AUDIT_PASS,
        reviewRemark: "",
      },
      formRules: {
        reviewStatus: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
        reviewRemark: [],
      },
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val) {
          this.formData = {
            reviewStatus: AUDIT_PASS,
            reviewRemark: "",
          };
          this.$nextTick(() => {
            this.$refs.formRef?.clearValidate();
          });
        }
      },
    },
    innerVisible(val) {
      this.$emit("update:visible", val);
    },
    "formData.reviewStatus"() {
      this.$nextTick(() => {
        this.$refs.formRef?.validateField("reviewRemark");
      });
    },
  },
  methods: {
    /** 关闭弹窗并重置表单 */
    onClose() {
      this.$refs.formRef?.resetFields();
      this.formData.reviewRemark = "";
      this.$emit("close");
    },
    /** 校验后提交提现审核 */
    onSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        if (!this.row.withdrawNo) {
          this.$message.warning("缺少记录信息");
          return;
        }
        this.submitting = true;
        try {
          await submitWithdrawalAuditAPI({
            withdrawNo: this.row.withdrawNo,
            reviewStatus: this.formData.reviewStatus,
            reviewRemark: this.formData.reviewRemark,
          });
          this.$message.success("提交成功");
          this.innerVisible = false;
          this.$emit("success");
        } catch {
          // http 已提示
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dlg-body {
  padding: 0 8px;
}
.info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 14px;
  font-size: 14px;
  line-height: 22px;
  .label {
    flex-shrink: 0;
    width: 100px;
    color: #606266;
  }
  .value {
    flex: 1;
    color: #303133;
    word-break: break-all;
  }
}
.dialog-footer {
  text-align: right;
}
</style>
